import React from 'react';
import { ClassNameValue, twMerge } from 'tailwind-merge';

interface SimpleDividerProps {
    className?: ClassNameValue;
}

const SimpleDivider = ({ className }: SimpleDividerProps) => (
    <div className={twMerge('my-6 h-px grow bg-gray-200', className)} />
);

interface Props {
    children?: string;
    className?: string;
}

const Divider = ({ children, className }: Props) => {
    const textColor = RegExp(/(text-[^\s]+)\s?/).exec(className)?.[1];

    return (
        <div className="divider flex items-center gap-x-2">
            <SimpleDivider className={className} />
            {children ? (
                <>
                    <div
                        className={twMerge(
                            'grow-0 py-1 text-xs font-bold text-gray-800',
                            textColor,
                        )}
                    >
                        {children}
                    </div>

                    <SimpleDivider className={className} />
                </>
            ) : null}
        </div>
    );
};

export default Divider;
